import {PatientEncounter} from '../../models/patient-encounter';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../../../shared/state/store';
import {useEffect, useState} from 'react';
import {
  DocumentsAccordionContentsV2,
  PatientDocument,
} from './documents-accordion-contents-v2';
import {client} from '../../../../shared/model/client';
import {getPatientDocuments} from '../../../state/patient-thunk';
import {
  getClient
} from '../../../../implementation-specialist/state/clients/implementation-clients-thunk';
import CustomizeableAccordion
  from '../../../../shared/components/customizeable-accordion';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {DocumentsAccordionContents} from './documents-accordion-contents';
import {patientService} from '../../../services/patient-service';
import {showErrorStatus} from '../../../../security/state/user-slice';

interface EncounterDocumentsAccordionProps {
  encounter: PatientEncounter;
}
export function EncounterDocumentsAccordion({
                                              encounter,
                                            }: EncounterDocumentsAccordionProps) {

  const dispatch = useDispatch<AppDispatch>();

  const [patientDocuments, setPatientDocuments] = useState<PatientDocument[] | null>(null);
  const [clientDetails, setClientDetails] = useState<client | null>(null);
  const [pEDocuments, setPEDocuments] = useState<Record<string, any>>({})

  const handleDocumentAccordionExpand = async (encounter: PatientEncounter) => {

    if (encounter?.patientId && encounter?.patientEncounterId) {

      //other documents can be found in the patientEncounter obj
      const s3DocumentResponse =  await patientService.getS3Documents(
          encounter?.patientId,
          encounter?.patientEncounterId
      )

      setPEDocuments({
        ...pEDocuments,
        [encounter?.patientEncounterId] : {
          s3Documents: !s3DocumentResponse.hasErrors ? s3DocumentResponse.entity: []
        }
      })
    }
  };

  useEffect(() => {

    (async () => {

      try{
        const [docs, details] = await Promise.all([
          dispatch(
              getPatientDocuments({
                encounterId: encounter.patientEncounterId,
                fetchSmsEligibility: false,
              }),
          ).unwrap(),
          dispatch(getClient(encounter.clientId)).unwrap(),
        ]);
        setPatientDocuments(docs);
        setClientDetails(details.fullClient);
      }catch(e){
        dispatch(showErrorStatus("Error retrieving document and/or client"))
        setPatientDocuments(null);
        setClientDetails(null);
      }

    })();

  }, [dispatch, encounter.patientEncounterId, encounter.clientId]);

  const isDocumentAccordionV2 =
      !!encounter.clientId &&
      clientDetails != null &&
      clientDetails.convRunNum != null &&
      clientDetails.convRunNum > 76;

  return (
      isDocumentAccordionV2 ?
          <CustomizeableAccordion
              icon={<InsertDriveFileIcon className="gray-icon" />}
              details={
                <div className="w-100">
                  <DocumentsAccordionContentsV2
                      documents={patientDocuments ?? []}
                      patientId={encounter.patientId}
                      patientEncounterId={encounter.patientEncounterId}
                  />
                </div>
              }
              hasScroll
              headerText="Documents"
              expandCallback={() => {}}
          /> :
          <CustomizeableAccordion
              icon={<InsertDriveFileIcon className="gray-icon" />}
              details={
                <div className="w-100">
                  <DocumentsAccordionContents
                      documents={encounter?.patientDocument}
                      selectedEncounter={encounter}
                      isAccountHolder
                      s3Documents={pEDocuments?.[encounter?.patientEncounterId]?.s3Documents || []}
                  />
                </div>
              }
              hasScroll
              headerText="Documents"
              expandCallback={async () => await handleDocumentAccordionExpand(encounter)}
          />
  )
}